module.exports = __webpack_public_path__ + "static/media/W19-0853_Wild_Cod_Mobile_Image_FR_767x845.a92084ca.jpg";